import React from 'react';
import { connect } from 'react-redux';

const LogoSide = ({ branding }) => {
  const { clientWebsite, name, logo } = branding;
  const { signInLogoSideBg } = branding?.colors || {};

  return (
    <div className='logoSide w-full md:w-1/2' style={{ background: signInLogoSideBg }}>
      <div className='logoDescription'>
        <img
          src={logo}
          alt={name}
          className='loginLogo'
          style={{ cursor: 'url(), pointer' }}
          onClick={() => window.open(`https://${clientWebsite}`, '_blank')}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    branding: state.branding,
  };
};
export default connect(mapStateToProps, null)(LogoSide);
